// ============================================================
// adminHelpers.js — Utilitaires partagés pour le dashboard admin
// ============================================================

/**
 * Formate une date en français
 * @param {string|Date} date
 * @returns {string}
 */
export function formatDate(date) {
  if (!date) return '—';
  return new Date(date).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

/**
 * Formate une date+heure en français
 * @param {string|Date} date
 * @returns {string}
 */
export function formatDateTime(date) {
  if (!date) return '—';
  return new Date(date).toLocaleString('fr-FR', {
    dateStyle: 'short',
    timeStyle: 'short',
  });
}

/**
 * Formate un montant en CDF
 * @param {number} amount
 * @returns {string}
 */
export function formatCurrency(amount) {
  if (amount == null || isNaN(amount)) return '0 FC';
  return new Intl.NumberFormat('fr-FR').format(amount) + ' FC';
}

/**
 * Calcule le temps écoulé depuis une date
 * @param {string|Date} dateString
 * @returns {string}
 */
export function getTimeAgo(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "À l'instant";
  if (diffMins < 60) return `Il y a ${diffMins} min`;
  if (diffHours < 24) return `Il y a ${diffHours}h`;
  if (diffDays < 7) return `Il y a ${diffDays}j`;
  return date.toLocaleDateString('fr-FR');
}

/**
 * Exporte un tableau d'objets en fichier CSV téléchargeable
 * Compatible Excel (BOM UTF-8)
 *
 * @param {string} filename  - nom du fichier sans extension
 * @param {Array<Object>} rows - tableau d'objets à exporter
 * @param {string[]} [columns] - liste ordonnée des clés à inclure (toutes si omis)
 * @param {Object} [headers]  - mapping clé → libellé colonne
 */
export function exportToCSV(filename, rows, columns, headers) {
  if (!rows || rows.length === 0) return;

  const cols = columns || Object.keys(rows[0]);
  const labelRow = cols.map(k => headers?.[k] || k);

  const escape = (val) => {
    if (val == null) return '';
    const str = String(val).replace(/"/g, '""').replace(/\r?\n/g, ' ');
    // Entoure de guillemets si virgule, point-virgule ou guillemet présent
    return /[,;"']/.test(str) ? `"${str}"` : str;
  };

  const lines = [
    labelRow.map(escape).join(','),
    ...rows.map(row => cols.map(k => escape(row[k])).join(',')),
  ];

  // BOM UTF-8 pour compatibilité Excel
  const bom = '\uFEFF';
  const blob = new Blob([bom + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
